import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Rect,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Path, { d: "m22 8-6 4 6 4V8Z", stroke: `${color}` }),
        /* @__PURE__ */ jsx(
          Rect,
          {
            width: "14",
            height: "12",
            x: "2",
            y: "6",
            rx: "2",
            ry: "2",
            stroke: `${color}`
          }
        )
      ]
    }
  );
};
Icon.displayName = "Video";
const Video = memo(themed(Icon));
export {
  Video
};
//# sourceMappingURL=video.js.map
